var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "analysisUserDetail" }, [
    _c("div", { attrs: { id: "graphs" } }, [
      _c("h1", [_vm._v(_vm._s(_vm.$t("Analysis.User.title01")))]),
      _c(
        "div",
        { staticClass: "events" },
        [
          _c("div", { staticClass: "profile" }, [
            _c("img", {
              staticClass: "thumb",
              attrs: { src: _vm.isEmptyImg(_vm.customer.image) },
            }),
            _c("span", { staticClass: "name" }, [
              _vm._v(_vm._s(_vm.customer.nickname)),
            ]),
            _c("span", { staticClass: "gender", class: _vm.customer.gender }, [
              _vm._v(_vm._s(_vm.makeGender())),
            ]),
            _c("span", { staticClass: "age" }, [_vm._v(_vm._s(_vm.makeAge()))]),
          ]),
          _c("Usage", {
            ref: "graph",
            staticClass: "graph",
            attrs: { width: 550, eventCounts: _vm.customer.event_counts },
          }),
        ],
        1
      ),
      _c("div", {
        staticClass: "legend",
        domProps: { innerHTML: _vm._s(_vm.legend) },
      }),
    ]),
    _c(
      "div",
      { attrs: { id: "eventList" } },
      [
        _c("h1", [_vm._v(_vm._s(_vm.$t("Analysis.User.title02")))]),
        _c("EventList"),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }